import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCustomer, updateCustomer } from 'slice/customerSlice';
import AdminTable from 'common/AdminTable';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useCities from 'hooks/useCities';
// import { useNavigate } from 'react-router-dom';

const ListCustomer = () => {
    const dispatch = useDispatch()
    const cartData = useSelector((state) => state.customer);
    const [showModal, setShowModal] = useState(false);
    const [refer, setRefer] = useState({})
    const [currentProduct, setCurrentProduct] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [creating, setCreating] = useState(false);
    const { cityOptions } = useCities();
    const [newCustomer, setNewCustomer] = useState({
        name: '',
        email: '',
        city: '',
        address: ''
    });
    // const navigate = useNavigate()

    useEffect(() => {
        Object.keys(refer).length ? dispatch(getCustomer(refer)) : dispatch(getCustomer())
    }, [dispatch, refer])

    // const handleEditClick = (product) => {
    //     setCurrentProduct(product);
    //     setShowModal(true);
    // };

    const referCheck = (id) => {

        if (id) {
            setRefer({
                id,
                refer: true
            })
        } else {
            setRefer({})
        }



    }

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentProduct(null);
    };

    const handleCreateChange = (event) => {
        const { name, value } = event.target;
        setNewCustomer((previous) => ({ ...previous, [name]: value }));
    };

    const handleCityChange = (selectedOption) => {
        setNewCustomer((previous) => ({ ...previous, city: selectedOption?.value || '' }));
    };

    const createCustomer = async (event) => {
        event.preventDefault();
        setCreating(true);
        try {
            const response = await postRequest('customer', newCustomer);
            if (response?.status >= 200 && response.status < 300) {
                toast.success('User created successfully.');
                setShowCreateModal(false);
                setNewCustomer({ name: '', email: '', city: '', address: '' });
                dispatch(getCustomer());
                return;
            }
            toast.error(response?.data?.message || 'Unable to create the user.');
        } catch (error) {
            toast.error(error?.message || 'Unable to create the user.');
        } finally {
            setCreating(false);
        }
    };

    // Handle saving the edited product
    const handleSave = () => {
        const formData = new FormData();
        formData.append('id', currentProduct.id);
        formData.append('status', currentProduct.status);
        formData.append('wallet', currentProduct.wallet);
        // Dispatch updateProduct with the formData
        dispatch(updateCustomer({ id: currentProduct.email, data: currentProduct }));
        handleCloseModal(); // Close modal after saving
    };

    // Table Headers
    const tableHeaders = [
        {
            Header: 'Name',
            accessor: 'name',
        },

        {
            Header: 'Mobile',
            accessor: 'mobile',
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <>
                    <span className={row.original.is_active ? 'badge badge-success' : 'badge badge-danger'}>
                        {row.original.is_active ? 'Active' : 'Inactive'}
                    </span>
                </>
            )
        },
        {
            Header: 'Join Date',
            accessor: 'createdAt'
        },
          {
            Header: 'City',
            accessor: 'city'
        },
        // {
        //     Header: 'Actions',
        //     accessor: 'actions',
        //     Cell: ({ row }) => (
        //         <>
        //             <button
        //                 className="btn editbtn mx-1 my-1"
        //                 onClick={() => handleEditClick(row.original)} // Correct function
        //             >
        //                 Updated
        //             </button>
        //         </>
        //     ),
        // }
    ];

    return (
        <>
            <div className='container-fluid mt-5'>
                <div className='mainheadig mx-4 d-flex'>
                    <h4 className='text-white font-weight-bold '>User List</h4>
                    <button className="ml-auto btn btn-success mr-2" onClick={() => setShowCreateModal(true)}>Create User</button>
                    <button className="btn btn-primary mr-4" onClick={() => referCheck(null)}><i className="fa fa-refresh" aria-hidden="true"></i></button>
                </div>
                {cartData?.data?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                ) : <p className='container-fluid bg-danger w-100 p-2  mx-4 text-center text-white'>No data found</p>}

                {showModal && currentProduct && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="editModalLabel">View User</h5>
                                    <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="form-group">
                                            <label htmlFor="status">Action</label>
                                            <select defaultValue={currentProduct.is_active} onChange={(e) => setCurrentProduct({ ...currentProduct, is_active: e.target.value })} className="form-control" id="productStatus">
                                                <option value={true}>Active</option>
                                                <option value={false}>Inactive</option>
                                            </select>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                    <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showCreateModal && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} tabIndex="-1" role="dialog" aria-labelledby="createUserModalLabel" aria-modal="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <form className="modal-content" onSubmit={createCustomer}>
                                <div className="modal-header">
                                    <h5 className="modal-title" id="createUserModalLabel">Create User</h5>
                                    <button type="button" className="close" onClick={() => setShowCreateModal(false)} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group"><label htmlFor="new-user-name">Name</label><input id="new-user-name" className="form-control" name="name" value={newCustomer.name} onChange={handleCreateChange} required /></div>
                                    <div className="form-group"><label htmlFor="new-user-mobile">Mobile number</label><input id="new-user-mobile" className="form-control" name="email" value={newCustomer.email} onChange={handleCreateChange} minLength="10" maxLength="10" required /></div>
                                    <div className="form-group"><label htmlFor="new-user-city">City</label><Select inputId="new-user-city" options={cityOptions} value={cityOptions.find((option) => option.value === newCustomer.city) || null} onChange={handleCityChange} placeholder="Search and select city" isSearchable required /></div>
                                    <div className="form-group mb-0"><label htmlFor="new-user-address">Address</label><textarea id="new-user-address" className="form-control" name="address" value={newCustomer.address} onChange={handleCreateChange} rows="3" required /></div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowCreateModal(false)}>Cancel</button>
                                    <button className="btn btn-success" disabled={creating}>{creating ? 'Creating…' : 'Create User'}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default ListCustomer;
